import React from 'react';
import { useRecoilValue } from 'recoil';
import { blockDisplayHeader, customizedBlock } from 'venn-state';
import { Block } from '../../components/core';
import { DefaultSubjects } from '../../components/secondary/subjects/default-subjects';
import { BenchmarkType } from '../../components/secondary/benchmark-type';

interface PrivatePerformanceSummaryHeaderProps {
  id: string;
}

export const PrivatePerformanceSummaryHeader = ({ id }: PrivatePerformanceSummaryHeaderProps) => {
  const { subHeader } = useRecoilValue(customizedBlock(id));
  const title = useRecoilValue(blockDisplayHeader(id));

  return (
    <>
      <Block.HeaderTopContainer id={id}>
        <Block.Title>
          <Block.Headline id={id}>{title}</Block.Headline>
          {subHeader && <Block.SubHeadline id={id}>{subHeader}</Block.SubHeadline>}
        </Block.Title>
        <Block.Metadata id={id}>
          <BenchmarkType id={id} />
        </Block.Metadata>
      </Block.HeaderTopContainer>

      <DefaultSubjects id={id} relativeToBenchmark={false} />
    </>
  );
};
